import { useContext, useEffect, useState } from "react";
import Accordion from "../../../components/misc/Accordion";
import SideBar from "../../../components/misc/SideBar";
import Slider from "../../../components/misc/Slider";
import Contacts from "../../../components/models/Contacts";
import ModelDetailsCard from "../../../components/models/ModelDetailsCard";
import ModelDetailsHeader from "../../../components/models/ModelDetailsHeader";
import ModelSpecsBar from "../../../components/models/ModelSpecsBar";
import WorkCategories from "../../../components/models/WorkCategories";
import useToggle from "../../../hooks/useToggle";
import Calendar from "../../../components/calendar/Calendar";
import LogMessage from "../../../components/misc/LogMessage";
import MyNavigator from "../../../components/misc/MyNavigator";
import NavBar from "../../../components/misc/NavBar";
import ProposalModal from "../../../components/modals/ProposalModal";
import ModelProposal from "../../../components/models/ModelProposal";
import MainContext from "../../../context/MainContext";
import useIsMobile from "../../../hooks/useIsMobile";
import useLogMessage from "../../../hooks/useLogMessage";
import "../../../styles/Content.css";
import "../../../styles/Models.css";
import { backToTopOfPage } from "../../../utils/others";
import { useForm } from "react-hook-form";
import EventModal from "../../../components/modals/EventModal";
import LocationModal from "../../../components/modals/LocationModal";
import { Event, Location } from "../../../interfaces";
import DeleteModal from "../../../components/modals/DeleteModal";
import useLocations from "../../../api/hooks/useLocations";
import { logMsgBgColors } from "../../../consts/misc";
import useEvents from "../../../api/hooks/useEvents";

const ModelDetailsPage = (props: any) => {
  const { isMobile } = useIsMobile();

  /* used for redirect */
  const navigateNow = useToggle(false);

  /* togglers */
  const menuToggler = useToggle(false);
  const togglerProposalModal = useToggle(false);
  const locationModalToggler = useToggle(false);
  const eventModalToggler = useToggle(false);
  const deleteModalToggler = useToggle(false);

  const anyModalOpen =
    togglerProposalModal.isToggled ||
    locationModalToggler.isToggled ||
    eventModalToggler.isToggled ||
    deleteModalToggler.isToggled;

  /* forms */
  const locationForm = useForm();
  const eventForm = useForm();
  const deleteModelForm = useForm();

  /* forms variables */
  const [onEdit, setOnEdit] = useState(false);
  const [locationSelected, setLocationSelected] = useState<Location | null>(
    null
  );
  const [eventSelected, setEventSelected] = useState<Event | null>(null);
  const [deleteType, setDeleteType] = useState<string | null>(null);

  /*  */
  const logMessage = useLogMessage();
  const messageOnScreen = useToggle(false);
  /*  */

  const { model, setRefresh } = useContext(MainContext);

  const locationHook = useLocations();
  const eventHook = useEvents();

  const tempLoading = useToggle(false);

  const handleCloseDeleteModal = () => {
    setOnEdit(false);
    setLocationSelected(null);
    deleteModelForm.reset();
    deleteModalToggler.toggle();
    locationModalToggler.setIsToggled(false);
    eventModalToggler.setIsToggled(false);
  };

  const onDeleteModelSubmit = (data: any) => {
    if (deleteType === "event" && eventSelected) {
      eventHook.CTAs.deleteEvents(data.id);
    } else if (deleteType === "location" && locationSelected) {
      locationHook.CTAs.deleteLocation(data.id);
    }
  };

  useEffect(() => {
    /* console.log(
      eventHook.RESPONSES.deleteEventsResponse,
      eventHook.RESULTS.deleteEventsResult
    ); */
    if (eventHook.RESPONSES.deleteEventsResponse?.ok) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write("subject", "Event ");
      logMessage.write("other_text", "has been deleted ");
      logMessage.write("complement", "successfully!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setRefresh((prevState) => !prevState);
      handleCloseDeleteModal();
    } else if (eventHook.RESPONSES.deleteEventsResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write(
        "subject",
        `Error ${eventHook.RESPONSES.deleteEventsResponse?.status}: `
      );
      logMessage.write(
        "other_text",
        `${eventHook.RESPONSES.deleteEventsResponse?.statusText}`
      );
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [eventHook.RESPONSES.deleteEventsResponse]);

  useEffect(() => {
    /* console.log(
      locationHook.RESPONSES.deleteLocationResponse,
      locationHook.RESULTS.createLocationResult
    ); */
    if (locationHook.RESPONSES.deleteLocationResponse?.ok) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write("subject", "Location ");
      logMessage.write("other_text", "has been deleted ");
      logMessage.write("complement", "successfully!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setRefresh((prevState) => !prevState);
      handleCloseDeleteModal();
    } else if (locationHook.RESPONSES.deleteLocationResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write(
        "subject",
        `Error ${locationHook.RESPONSES.deleteLocationResponse?.status}: `
      );
      logMessage.write(
        "other_text",
        `${locationHook.RESPONSES.deleteLocationResponse?.statusText}`
      );
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [locationHook.RESPONSES.deleteLocationResponse]);

  /*   useEffect(() => {
    if (eventModalToggler.isToggled) {
      backToTopOfPage();
    }
  }, [eventModalToggler]); */

  /*  */
  useEffect(() => {
    if (messageOnScreen.isToggled) {
      setTimeout(() => {
        messageOnScreen.toggle();
        if (props.togglerProposalModal) props.togglerProposalModal.toggle();
      }, 3000);
    }
  }, [messageOnScreen]);
  /*  */

  useEffect(() => {
    if (model === null && window.location.pathname.includes("/models/")) {
      navigateNow.setIsToggled(true);
    } else backToTopOfPage();
  }, []);

  useEffect(() => {
    if (navigateNow.isToggled) {
      navigateNow.setIsToggled(false);
    }
  }, [navigateNow]);

  useEffect(() => {
    if (tempLoading.isToggled) {
      /* caricamento */
      logMessage.setMessageTimer(20000);
      logMessage.write("subject", "Loading . . .");
      logMessage.write("bgColor", logMsgBgColors.loading);
    } else if (!tempLoading.isToggled) {
      logMessage.setMessageTimer(null);
    }
  }, [tempLoading.isToggled]);

  return (
    <div className={`page-wrapper`}>
      {deleteModalToggler.isToggled && (
        <form onSubmit={deleteModelForm.handleSubmit(onDeleteModelSubmit)}>
          <DeleteModal
            toggler={deleteModalToggler}
            register={deleteModelForm.register}
            reset={deleteModelForm.reset}
            location={locationSelected}
            event={eventSelected}
            deleteType={deleteType}
          />
        </form>
      )}
      {eventModalToggler.isToggled && (
        <EventModal
          toggler={eventModalToggler}
          form={eventForm}
          logMessage={logMessage}
          messageOnScreen={messageOnScreen}
          onEdit={onEdit}
          setOnEdit={setOnEdit}
          setEventSelected={setEventSelected}
          eventSelected={eventSelected}
          deleteModalToggler={deleteModalToggler}
          setDeleteType={setDeleteType}
          tempLoading={tempLoading}
          message={logMessage.message}
        />
      )}
      {locationModalToggler.isToggled && (
        <LocationModal
          toggler={locationModalToggler}
          form={locationForm}
          logMessage={logMessage}
          messageOnScreen={messageOnScreen}
          onEdit={onEdit}
          setOnEdit={setOnEdit}
          setLocationSelected={setLocationSelected}
          locationSelected={locationSelected}
          deleteModalToggler={deleteModalToggler}
          setDeleteType={setDeleteType}
          tempLoading={tempLoading}
          message={logMessage.message}
        />
      )}
      {togglerProposalModal.isToggled && (
        <ProposalModal
          togglerProposalModal={togglerProposalModal}
          message={logMessage.message}
          write={logMessage.write}
          messageOnScreen={messageOnScreen}
          model={model}
        />
      )}
      <MyNavigator path={`/models`} trigger={navigateNow} />
      {(!isMobile || menuToggler.isToggled) && (
        <SideBar toggler={menuToggler} />
      )}

      {messageOnScreen.isToggled && (
        <LogMessage
          text={{
            subject: logMessage.message.subject,
            other_text: logMessage.message.other_text,
            complement: logMessage.message.complement,
          }}
          bgColor={logMessage.message.bgColor}
        />
      )}
      {/*  */}
      <div>
        {isMobile && <NavBar toggler={menuToggler} />}
        <div
          className={`page-content ${
            isMobile && menuToggler.isToggled
              ? menuToggler.isToggledSecondary
                ? "slide-right"
                : "slide-left"
              : ""
          }`}
          style={{
            maxWidth: isMobile ? "" : "calc(100vw - 256px)",
            minWidth: isMobile ? "" : "1175px",
            marginLeft: isMobile
              ? menuToggler.isToggled
                ? "256px"
                : ""
              : "256px",
            display: anyModalOpen && isMobile ? "none" : "",
          }}
        >
          <ModelDetailsHeader
            togglerProposalModal={togglerProposalModal}
            model={model}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <div>
              <ModelDetailsCard model={model} />
              <ModelSpecsBar model={model} />
            </div>
            <Contacts model={model} />
          </div>
          <ModelProposal model={model} />
          <WorkCategories model={model} />
          <div
            className="divider-large"
            style={{
              width: isMobile ? "345.7px" : "",
              margin: isMobile ? "30px " : "",
              padding: isMobile ? "0" : "",
            }}
          />
          <div>
            <Accordion
              element={
                <Slider classChosen={`photo`} data={model?.portfolio?.photos} />
              }
              sectionName={`Photos${
                model?.portfolio?.photos && model?.portfolio?.photos.length > 0
                  ? " (" + model?.portfolio?.photos.length + ")"
                  : ""
              }`}
            />
          </div>
          <div
            className="divider-large"
            style={{
              width: isMobile ? "345.7px" : "",
              margin: isMobile ? "30px " : "",
              padding: isMobile ? "0" : "",
            }}
          />
          <div>
            <Accordion
              element={
                <Slider
                  classChosen={"polaroid"}
                  data={model?.portfolio?.polaroids}
                />
              }
              sectionName={`Polaroids${
                model?.portfolio?.polaroids.length &&
                model?.portfolio?.polaroids.length > 0
                  ? " (" + model?.portfolio?.polaroids.length + ")"
                  : ""
              }`}
            />
          </div>
          <div
            className="divider-large"
            style={{
              width: isMobile ? "345.7px" : "",
              margin: isMobile ? "30px " : "",
              padding: isMobile ? "0" : "",
            }}
          />
          <div>
            <Accordion
              element={
                <Slider classChosen={"video"} data={model?.portfolio?.videos} />
              }
              sectionName={`Videos${
                model?.portfolio?.videos && model?.portfolio?.videos.length > 0
                  ? " (" + model?.portfolio?.videos.length + ")"
                  : ""
              }`}
            />
          </div>
          <div
            className="divider-large"
            style={{
              width: isMobile ? "345.7px" : "",
              margin: isMobile ? "30px " : "",
              padding: isMobile ? "0" : "",
            }}
          />
          <div>
            <Accordion
              element={
                <Slider
                  classChosen={"document"}
                  data={model?.portfolio?.documents}
                />
              }
              sectionName={`Document${
                model?.portfolio?.documents &&
                model?.portfolio?.documents.length > 0
                  ? " (" + model?.portfolio?.documents.length + ")"
                  : ""
              }`}
            />
          </div>
          <Calendar
            eventToggler={eventModalToggler}
            setEventSelected={setEventSelected}
            locationToggler={locationModalToggler}
            setLocationSelected={setLocationSelected}
            setOnEdit={setOnEdit}
          />
        </div>
      </div>
    </div>
  );
};
export default ModelDetailsPage;
